import { type ContentObjectDetail, createContentObjectDetail } from 'models';
import { type UseQueryOptions, useQuery } from 'query';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { getContentObject } from '../../services';
import { getContentObjectDetailQueryKey } from '../keys';

export const useContentObjectQuery = (
  id: string,
  queryOptions?: Omit<
    UseQueryOptions<ContentObjectDetail, ApiClientResponseError<ResponseErrorDataObject>>,
    'queryFn' | 'queryKey'
  >,
) =>
  useQuery<ContentObjectDetail>({
    gcTime: 0,
    async queryFn() {
      const { data } = await getContentObject({ config: { params: {} }, routeParams: { id } });

      return createContentObjectDetail(data);
    },
    queryKey: getContentObjectDetailQueryKey({ id }),
    staleTime: 0,
    ...queryOptions,
  });
